import React, { FunctionComponent } from 'react'
import RouteTabLink from '../Tab/RouteTabLink'

const TeamNavBar: FunctionComponent = () => {
  return (
    <div className='tab'>
      <header>
        <div className='auto'>
          <h2>My team</h2>

          <div className='tabs'>
            <ul className='auto'>
              <RouteTabLink path='/my-team'>Members</RouteTabLink>

              <RouteTabLink path='/my-team/monitoring'>Monitoring</RouteTabLink>

              <RouteTabLink path='/my-team/settings'>Settings</RouteTabLink>
            </ul>
          </div>
        </div>
      </header>
    </div>
  )
}

export default TeamNavBar
